import { camel } from 'to-case'

export function toCamel (obj) {
  let newObj = {}

  Object.keys(obj).forEach(key => {
    if (obj[key] instanceof Object) {
      newObj[camel(key)] = toCamel(obj[key])
    } else {
      newObj[camel(key)] = obj[key]
    }
  })

  return newObj
}



// WEBPACK FOOTER //
// ./src/helpers/format.js